/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'ico-inst': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-ico-inst-a" transform="translate(2 2)"/><defs><path pid="0" id="svgicon-ico-inst-a" d="M16.325 4.775a1.158 1.158 0 1 1-2.316 0 1.158 1.158 0 0 1 2.316 0zM20 10v.015l-.066 4.195a5.79 5.79 0 0 1-5.724 5.724L10 20h-.015l-4.195-.066A5.79 5.79 0 0 1 .066 14.21L0 10v-.015L.066 5.79A5.79 5.79 0 0 1 5.79.066L10 0h.015l4.195.066a5.79 5.79 0 0 1 5.724 5.724L20 10zm-1.863 0l-.065-4.181a3.936 3.936 0 0 0-3.891-3.891L10 1.863l-4.181.065a3.936 3.936 0 0 0-3.891 3.891L1.863 10l.065 4.181a3.936 3.936 0 0 0 3.891 3.891l4.181.065 4.181-.065a3.935 3.935 0 0 0 3.891-3.891L18.138 10zm-3.002 0a5.135 5.135 0 1 1-10.27 0 5.135 5.135 0 0 1 10.27 0zm-1.862 0a3.273 3.273 0 1 0-6.547 0 3.273 3.273 0 0 0 6.547 0z"/></defs>`
  }
})
